<template>
  <div class="row boxes-row">
    <div class="col-lg-6"  v-for="file in files" :key="file.idFile">
      <BoxFile :box="file"/>
    </div>
  </div>
</template>

<script>
import BoxFile from "@/components/files/BoxFile";
export default {
name: "FilesGrid",
  props: ['files'],
  components: {BoxFile}
}
</script>

<style scoped>

</style>